export { List } from "@mantine/core";
export type { ListProps } from "@mantine/core";
export { getListOverrides } from "./List.styled";
